var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentGenerationInactive = function SvgContentGenerationInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    fillRule: "evenodd",
    d: "m4.526 17.526.905-2.716h1.138l.905 2.716 2.716.905v1.138l-2.716.905-.905 2.716H5.431l-.905-2.716-2.716-.905v-1.138l2.716-.905Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M12.305 3H12.018h.287ZM12 3H9.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 7.29 4 7.954 4 8.758V13h3.5l1 3 3.5 1v4h2.241c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V11h-7a1 1 0 0 1-1-1V3ZM20 10.988v-.294.294Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M19.802 9a4.002 4.002 0 0 0-.391-.847c-.249-.406-.588-.745-1.038-1.194l-2.332-2.332c-.449-.45-.788-.789-1.194-1.038A3.998 3.998 0 0 0 14 3.198V9h5.802Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "m5.5 14.5-1 3-3 1v1l3 1 1 3h1l1-3 3-1v-1l-3-1-1-3h-1Z"
  })));
};
export default SvgContentGenerationInactive;